export default __webpack_public_path__ + "static/media/(30).6132debd.JPG";